"use strict";

(function () {
  function dispatchThemeLoadingStart() {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:start", { bubbles: true }),
    );
  }

  function dispatchThemeLoadingEnd() {
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:loading:end", { bubbles: true }),
    );
  }

  /**
   * Async add of an upsell product to the cart.
   * Unlike the standard product add, this does NOT open the cart drawer.
   */
  async function addUpsellVariantToCart(variantId, button, card) {
    const sectionsToBundle = [];

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }),
    );

    dispatchThemeLoadingStart();

    button.setAttribute("aria-busy", "true");
    card.classList.add("is-adding");

    const addingLabel = button.getAttribute("data-adding-label");

    if (addingLabel) {
      button.textContent = addingLabel;
    }

    let added = false;

    try {
      const formData = new FormData();
      formData.set("id", variantId);
      formData.set("quantity", "1");
      formData.set("on_success", "none");
      formData.set("sections", sectionsToBundle.join(","));
      formData.set(
        "sections_url",
        `${Shopify.routes.root}variants/${variantId}`,
      );

      // window.themeCart (assets/poelle.js): the request with a time limit, that always answers
      const result = await window.themeCart.add(formData);
      const responseJson = result.json;

      if (!result.ok) {
        button.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson.description,
            },
          }),
        );

        if (result.failed) {
          // no answer from the server: say so under the card
          window.themeCart.showError(
            card,
            responseJson.description,
            "afterend",
          );
        } else {
          document.dispatchEvent(new CustomEvent("cart:refresh"));
        }

        return;
      }

      const settings =
        (window.themeVariables && window.themeVariables.settings) || {};

      if (settings.cartType === "page" || settings.pageType === "cart") {
        window.location.href = `${Shopify.routes.root}cart`;
        return;
      }

      const cartContent = result.cart;

      if (!cartContent) {
        // added, but the cart could not be read back
        document.dispatchEvent(new CustomEvent("cart:refresh"));
        setAddedState(button, card);
        added = true;
        return;
      }

      cartContent.sections = responseJson.sections;

      // Update cart state (count, drawer content) WITHOUT opening the drawer.
      // The drawer only opens when baseEvent === "variant:add" (see CartDrawer),
      // so we use a custom baseEvent to refresh the cart silently.
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:change", {
          bubbles: true,
          detail: {
            baseEvent: "upsell:add",
            onSuccessDo: "none",
            cart: cartContent,
          },
        }),
      );

      setAddedState(button, card);
      added = true;
    } finally {
      dispatchThemeLoadingEnd();
      button.removeAttribute("aria-busy");
      card.classList.remove("is-adding");

      // If the request failed, restore the default "add" label.
      if (!added) {
        const addLabel = button.getAttribute("data-add-label");
        if (addLabel) {
          button.textContent = addLabel;
        }
      }
    }
  }

  function setAddedState(button, card) {
    card.classList.add("is-added");
    button.classList.add("is-added");
    button.disabled = true;

    const addedLabel =
      button.getAttribute("data-added-label") || "Added";

    button.textContent = addedLabel;
  }

  function resetAddedState(button, card) {
    card.classList.remove("is-added");
    button.classList.remove("is-added");
    button.disabled = false;

    const addLabel = button.getAttribute("data-add-label");
    if (addLabel) {
      button.textContent = addLabel;
    }
  }

  function handleCartChange(event) {
    const cart = event.detail && event.detail.cart;
    const items = (cart && cart.items) || [];
    const productIdsInCart = new Set(
      items.map((item) => String(item.product_id)),
    );

    document
      .querySelectorAll(".additional-card.is-added")
      .forEach((card) => {
        const productId = card.getAttribute("data-upsell-product-id");

        if (productId && !productIdsInCart.has(productId)) {
          const button = card.querySelector(".upsell-add-button");

          if (button) {
            resetAddedState(button, card);
          }
        }
      });
  }

  // When an item is removed from the cart (mini-cart / cart drawer),
  // re-enable the matching upsell card so it can be added again.
  document.addEventListener("cart:change", handleCartChange);

  function addToCartFromCartChange(card, button) {
    const productId = card.getAttribute("data-upsell-product-id");

    if (!productId) {
      return;
    }

    // If the product is already rendered as "added", skip.
    if (card.classList.contains("is-added")) {
      return;
    }

    addUpsellVariantToCart(
      button.getAttribute("data-upsell-variant-id"),
      button,
      card,
    );
  }

  document.addEventListener(
    "click",
    (event) => {
      const addButton = event.target.closest(".upsell-add-button");

      if (!addButton) {
        return;
      }

      if (addButton.getAttribute("aria-busy") === "true") {
        return;
      }

      if (addButton.classList.contains("is-added")) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const card = addButton.closest(".additional-card");

      if (!card) {
        return;
      }

      addToCartFromCartChange(card, addButton);
    },
    true,
  );
})();
